<template>
<v-container>
  <v-row>
    <v-col cols="12">
      <v-overlay :value="loading">
        <v-progress-circular
            indeterminate
            size="64"
        ></v-progress-circular>
      </v-overlay>
      <v-card>
        <v-toolbar dark class="primary">
          <v-toolbar-title>Zmiana hasła</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-progress-linear :indeterminate="true" v-if="saving"></v-progress-linear>
          <v-form :class="visibility_class" @submit="handleSubmit"  v-model="valid"  ref="form" lazy-validation>
            <v-container>
              <v-row>
                <v-col cols="12" v-if="wymuszona_zmiana">
                  <p class="subtitle-1 font-weight-medium text-center" style="color:red" >Twoje hasło wymaga zmiany. Wprowadź proszę nowe hasło.</p>
                </v-col>
                <v-col cols="12">
                  <v-text-field label="Podaj swoje aktualne hasło*" :rules="[required]" v-model="current_user_password" type="password"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field label="Hasło*"  :rules="[required,min8]" counter  v-model="password" ref="password" :type="'password'" :append-icon="'fa-eye-slash'"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field label="Powtórz hasło*" :rules="[required,matchingPasswords]"  counter v-model="repeat_password"  :type="'password'"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <p class="subtitle-1 font-weight-medium text-center">Nowe hasło powinno zawierać co najmniej 8 znaków, jedną małą literę, jedną duża literę i jeden ze znaków specjalnych: [!*@#$%^&+=]</p>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeForm" color="error">Anuluj</v-btn>
          <v-btn color="success"   @click="handleSubmit">Zapisz</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import swal from "sweetalert";
import {userService} from "@/services";


export default {
  name: "ChangePassword",
  data() {
    return {
      saving: false,
      current_user_password: null,
      repeat_password: null,
      password: null,
      visibility_class: "row",
      loading: false,
      valid:true,
    }
  },
  mounted() {

  },
  computed: {
    wymuszona_zmiana: function() {
      return this.$route.query.force;
    }
  },
  methods: {
    showError(close, text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        this.loading = false;
        if (close) {
          this.$emit("close");
        }
      });
    },
    closeForm() {
      this.$router.push('/')
    },
    handleSubmit() {
      if (this.$refs.form.validate()) {
          this.resetPassword();
       }

    },
    resetPassword() {
      this.loading  = true;
      userService
          .changePassword({
            currentPassword: this.current_user_password,
            newPassword: this.password
          })
          .then(() => {
            this.loading = false;

            const loggedIn = localStorage.getItem('user');
            if (loggedIn) {
              const obj = JSON.parse(loggedIn)
              obj.forceResetPasswordAtLogin = false
              localStorage.setItem('user', JSON.stringify(obj));
            }
            swal("Gotowe", "Zresetowano hasło", "success").then(() => {
              this.$router.push('/')
            });

          })
          .catch(resp => {
            if (
                resp.response != null &&
                resp.response.data != null &&
                resp.response.data.error != null
            ) {
              this.showError(false, resp.response.data.error.message);
            } else {
              this.showError(false, "Błąd resetu hasła");
            }
          });
    },
    required: function (value) {
      if (value) {
        return true;
      } else {
        return 'To pole jest wymagane.';
      }
    },
    min8: function (value) {
      if (value && value.length >= 8) {
        return true;
      } else {
        return 'Hasło powinno posiadać przynajmniej 8 znaków.';
      }
    },
    matchingPasswords: function () {
      if (this.password === this.repeat_password) {
        return true;
      } else {
        return 'Hasła się nie zgadzają.';
      }
    }
  }
}
</script>

<style scoped>

</style>